import { getSupabase } from '@/lib/supabase';
import type { PlayerEvent } from '@/schemas';
import type { UserId } from '@/schemas/ids';
import { decodeRowToPlayerEvent, type PlayerEventRow } from '../codec';
import { getUserSyncState, setUserLastDownloadedAt } from '../state';

export interface DownloadResult {
  events: PlayerEvent[];
}

export async function downloadRemotePlayerEvents(userId: UserId): Promise<DownloadResult> {
  const client = getSupabase();
  const {
    data: { session },
  } = await client.auth.getSession();
  if (!session?.user) {
    throw new Error('User must be authenticated to sync player events');
  }

  const { lastDownloadedAt = 0 } = await getUserSyncState(userId, 'player_events');
  const { data, error } = await client
    .from('player_events')
    .select<'*', PlayerEventRow>('*')
    .eq('user_id', userId)
    .gt('timestamp', lastDownloadedAt)
    .order('timestamp', { ascending: true })
    .limit(1000);
  if (error) throw error;
  const events = (data ?? []).map((row) => decodeRowToPlayerEvent(row));
  if (events.length > 0) {
    await setUserLastDownloadedAt(userId, 'player_events', events.at(-1)!.timestamp);
  }
  return { events };
}
